import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import ShortInfo from './../block/ShortInfo'
import Cards1 from './../block/Cards1'
import Kontakti from './../block/Kontakti'
import GreenButton from './../block/GreenButton'
import FeedbackForm from './../block/FeedbackForm'

import styles from './../style/Restovraciya.module.scss'

import { Container, Image } from 'react-bootstrap'

class Restovraciya extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  render() {

    const { data, protocol, assets_path } = this.props,
    { show_feedback } = this.state

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
          className={`short`}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.mimozem?.list || []}
          cols={4}
          title={data?.mimozem?.title || ``}
          margin={`top`}
          layout={9}
        />
        <Cards1
          list={data?.mimozem?.list2 || []}
          cols={3}
          margin={`none`}
        />
        <Container>
          <div className={styles.card}>
            <div className={styles.card_left}>
              <Image src={`/${assets_path}/images/solana-(sol).svg`} width={18} height={18} alt={`рес`} />
              <div>Реставрация старых окон, выполненная профессионалами, дает возможность вернуть деревянным частям прежний вид.</div>
            </div>
            <GreenButton
              text={`Заказать звонок`}
              width={169}
              className={styles.btn}
              action={() => this.showFeedback()}
            />
          </div>
        </Container>
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
        <FeedbackForm
          title={`Заказать звонок`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </>
    )
  }
}

Restovraciya.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Restovraciya.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Restovraciya